(function (app, $) {
    $(document).ready(function () {
        if ($('.page_login').length > 0) {
            $('#access_code_submit').on('click', function (e) {
                e.preventDefault();
                var $form = $("#form_access_code");

                var emptyItem = $form.find('[required]').filter(function () {
                    return !this.value;
                });

                if (emptyItem.length > 0) {
                    $form.closest('.modal').find('.form-error').text(app.resources.emptyFields).removeClass('d-none');
                    return false;
                }

                $('.form-error').addClass('d-none');

                $.get(app.routes.login.checkAccessCode, $form.serialize())
                    .done(function () {
                        $form.submit();
                    })
                    .fail(function (xhr, status, error) {
                        $form.closest('.modal').find('.form-error').text(app.resources.modalcodeerrorset).removeClass('d-none');
                    });

                return false;
            });

            $('#reset_pass_submit').on('click', function (e) {
                e.preventDefault();
                var $form = $("#form_reset_pass");

                var emptyItem = $form.find('[required]').filter(function () {
                    return !this.value;
                });

                if (emptyItem.length > 0) {
                    $form.closest('.modal').find('.form-error').text(app.resources.emptyFields).removeClass('d-none');
                    return false;
                }
                
                $('.form-error').addClass('d-none');

                $.get(app.routes.login.checkEmail, $form.serialize())
                    .done(function () {
                        $.post($form.attr('action'), $form.serialize())
                            .done(function () {
                                $form.closest('.modal').modal('hide');
                                $('#alert_success').removeClass('d-none')
                                    .find('.alert-text').text(app.resources.loginresetpaswwordmsg);
                            })
                            .fail(function (xhr, status, error) {
                                $form.closest('.modal').find('.form-error').text(app.resources.erroroccured).removeClass('d-none');
                                console.error('Error while sending reset password email', status, error);
                            });
                    })
                    .fail(function (xhr, status, error) {
                        $form.closest('.modal').find('.form-error').text(app.resources.modalreseterroremail).removeClass('d-none');
                    });

                return false;
            });
        }
    });
})(window.app = window.app || {}, jQuery);